module.exports = __webpack_public_path__ + "img/1.38c8c285.png";